import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPhone} from '@fortawesome/free-solid-svg-icons'
import Image from 'next/image'
import computerSearch from '/public/images/computer-search.jpg'

export default function TutorSearchBanner() {
  return (
    <div className="d-md-flex rounded border bg-white">
      <div className="flex-grow-1 p-4">
        <h2 className="mb-2 text-primary">Need a hand with your search?</h2>
        <h5 className="mb-3 text-muted">We can help you find the perfect tutor. Give us a call!</h5>
        <p className="phone-cta">
          <FontAwesomeIcon icon={faPhone} size="lg" className="me-2 text-info" />
          <a href="tel:+441509265623" className="text-primary">01509 265 623</a>
        </p>
      </div>
      <Image
        src={computerSearch}
        width={350}
        height="100%"
        alt="We can help with your search"
        className="rounded-right"
        style={{
          maxWidth: "100%",
          height: "auto",
          objectFit: "cover",
          objectPosition: "center"
        }} />
    </div>
  )
}
